import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#activity_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Asset Register Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organization Type", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_16 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_18 = { class: "col-md-3 mt-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Active", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Pending", -1)
const _hoisted_23 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "col-md-2 mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_26 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex pt-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
      ])
    ])
  ])
], -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, null, -1)
const _hoisted_31 = { class: "row w-100 mb-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, null, -1)
const _hoisted_33 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "position-relative" }
const _hoisted_41 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_42 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#activity-report",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_43 = { class: "card-title m-0" }
const _hoisted_44 = { class: "fw-bolder m-0" }
const _hoisted_45 = {
  id: "activity-report",
  class: "collapse show"
}
const _hoisted_46 = { class: "collapse show" }
const _hoisted_47 = {
  style: {"overflow":"scroll"},
  class: "card-body border-top p-9"
}
const _hoisted_48 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #1c1e1d"}
}
const _hoisted_49 = { style: {"border-left":"1.5px solid #1c1e1d"} }
const _hoisted_50 = { style: {"border-bottom":"1px solid #1c1e1d"} }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("th", null, "Sl", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Training Partner", -1)
const _hoisted_53 = {
  key: 0,
  style: {"text-align":"center","min-width":"200px"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","min-width":"200px"} }, "Total Asset", -1)
const _hoisted_55 = { style: {} }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "",
                          label: "Select Tranche"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Select Tranche")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: trans.id,
                            label: trans.label,
                            value: trans.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(trans.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Type",
                      modelValue: _ctx.type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                      style: {"width":"100%"},
                      onChange: _ctx.btnCheckStatus
                    }, {
                      default: _withCtx(() => [
                        (_ctx.is_seip_user == true)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              value: "SEIP"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("SEIP")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.is_seip_user == true || _ctx.is_entity_user == true)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: "Training Partner"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Training Partner")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.is_seip_user == true || _ctx.is_institute_user == true)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 2,
                              value: "Training Institute"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Training Institute")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  (_ctx.btnCheck)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Partner",
                          modelValue: _ctx.batch.entity_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          onChange: _ctx.getTrainingInstitute
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: data.id,
                                label: '[' + data.entity_short_name + '] - ' + data.entity_name
                                            ,
                                value: data.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "entity_id",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.instituteCheck)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Institute",
                          modelValue: _ctx.batch.institute_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                          name: "institute_id",
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: info.id,
                                label: info.institute_name,
                                value: info.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(info.institute_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      placeholder: "Status",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event)),
                      style: {"width":"100%"}
                    }, _hoisted_23, 512), [
                      [_vModelSelect, _ctx.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_ctx.type)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseActivityReport())),
                          type: "button",
                          class: "btn btn-success mt-6 p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_25
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_26, [
                          _createTextVNode(" Search "),
                          _hoisted_27
                        ]))
                  ])
                ]),
                _hoisted_28,
                (_ctx.showReport)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_35),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_37),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_39)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("h3", _hoisted_44, "Organization Type:" + _toDisplayString(this.type), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("table", _hoisted_48, [
                                  _createElementVNode("thead", _hoisted_49, [
                                    _createElementVNode("tr", _hoisted_50, [
                                      _hoisted_51,
                                      _hoisted_52,
                                      (_ctx.type == 'Training Institute')
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_53, "Training Institute"))
                                        : _createCommentVNode("", true),
                                      _hoisted_54
                                    ])
                                  ]),
                                  _createElementVNode("tbody", _hoisted_55, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.activityReport, (data, inx) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: inx,
                                        class: "border border-gray-400 text-center"
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                        _createElementVNode("td", null, [
                                          (_ctx.type == 'Training Partner')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(data?.entity_short_name), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.type == 'Training Institute')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(data?.entity_name?.entity_short_name), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.type == 'Training Institute')
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                                              _createElementVNode("span", null, _toDisplayString(data?.institute_name), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", null, _toDisplayString(data.asset_info.length), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}